
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { ConstantsService } from 'app/services/constants-service';
import { Communication } from 'app/entities/details/contactinformation/communication.model';
import { ObservableRequestService } from 'app/services/observable-request.service';

/**
 * Service for contact details component.
 */
@Injectable()
export class ContactService {

  constructor(private requestService: ObservableRequestService) { }

  loadContactDetails(id: number, client: any): Observable<any> {
    return this.requestService.getRequest(
        `${(client === 'Person' ? ConstantsService.LIST_PERSON_CONTACT_DETAILS : ConstantsService.LIST_ORG_CONTACT_DETAILS)}/${id}`
    );
  }

  deleteContact(contactInfo: Object): Observable<any> {
    return this.requestService.deleteRequest(
      ConstantsService.DELETE_ORG_CONTACT,
      this.requestService.serialize(contactInfo),
      this.requestService.getFormEncodedContentType());
  }

  addContact(contact: Communication, entityType: string): Observable<any> {
    return this.requestService.postRequest(
      ConstantsService.ADD_CONTACT,
      JSON.stringify(contact),
      this.requestService.getJSONContentType());
  };

  updateContact(contact: Communication, entityType: string): Observable<any> {
    return this.requestService.putRequest(
      ConstantsService.ADD_CONTACT,
      JSON.stringify(contact),
      this.requestService.getJSONContentType());
  };
}



// WEBPACK FOOTER //
// ./src/app/entities/details/contactinformation/contact.service.ts